import { APIError } from '../core/errors';
import httpClient from '../services/http.service';
import { BASE_URL, DEFAULT_HEADERS } from './api-constants';
//import {setAccessToken} from '../core/localstorage-data'

//TODO: - write the API calls here
const _api_base_url = `${BASE_URL}/otp/send`;
const _otp_verify_url = `${BASE_URL}/auth/verify`;

interface otpResponse {
  token: string;
}
interface otpVerifyResponse {
  access_token: string;
}

interface payloadVerify {
  token: string;
  mobileNum: string;
  code: string;
}
// interface otpSendData {

//   mobileNum:string

// }
//let userEnterMobileNumber = '';

// test user fetch.
// TODO: remove later
export const getOtp = async (payload: string): Promise<otpResponse> => {
  //userEnterMobileNumber=mobileNumber;
  const otpData = {
    mobileNum: payload,
  };
  try {
    const response = await httpClient.post(`${_api_base_url}`, otpData, {
      headers: {...DEFAULT_HEADERS},
    });

    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};

export const verifyOtp = async (
  payload: payloadVerify,
): Promise<otpVerifyResponse> => {
  //userEnterMobileNumber=mobileNumber;
  try {
    const response = await httpClient.post(`${_otp_verify_url}`, payload, {
      headers: {...DEFAULT_HEADERS},
    });

    return response.data;
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
